import { makeAutoObservable } from 'mobx';
import API_URL from '../../config/ApiUrl';
import RootStore from '../RootStore/RootStore';
import { ServerGridConfig } from '../../config/GridConfig';
import axios from 'axios';

export default class PublicSettingsStore {
	searchValue = '';
	publicSettingDetail = null;

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			// called by the grid when more rows are required
			getRows: (params) => {
				// get data for request from server
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue
				);
				this.getList(payload)
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};

	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.PUBLICSETTINGS.LIST}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1`
			);
			return data.data;
		} catch {}
	};

	addPublicSettings = async (formData) => {
		return await axios
			.post(API_URL.PUBLICSETTINGS.ADD, formData)
			.then(({ data }) => {
				this.setupGrid(this.agGrid);
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	readPublicSettings = async (id) => {
		try {
			const { data } = await axios.get(
				`${API_URL.PUBLICSETTINGS.SINGLE}?id=${encodeURIComponent(id)}`
			);
			this.publicSettingDetail = data.data;
			return data.data;
		} catch {}
	};

	editPublicSettings = async (formData) => {
		return await axios
			.put(API_URL.PUBLICSETTINGS.UPDATE, formData)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};
}
